<template>
  <div class="preview" :class="types">
    <div class="inner">

      <router-link :to="`/portfolio/${project.slug}`" class="router-link">
        <div class="project-img" :style="{backgroundImage: `url(${ imageSrc })`}" :alt="project.alt">
          <div class="overlay">
            <h4 class="project-name">{{ project.name }}</h4>
            <h4 class="project-type">{{ type }}</h4>
            <a class="btn btn-default" role="button">view project</a>
          </div>
        </div>
      </router-link>

    </div>
  </div>
</template>

<script>
  export default {

    props: ['project'],

    computed: {

      type() {
        return this.project.type.filter(t => t.toLowerCase() !== 'all')[0];
      },

      types() {
        return this.project.type.map(t => t.toLowerCase());
      },

      imageSrc() {
        // eslint-disable-next-line global-require, prefer-template, import/no-dynamic-require
        return require('../assets/images/projects/' + this.project.slug + '/preview.png');
      },
    },

  };
</script>

<style scoped lang="scss">
  .router-link {
    display: inline-block;
    border-radius: 50%;
  }

  .project-img {
    display: table;
    position: relative;
    height: 230px;
    width: 230px;
    margin: 0 auto;
    border-radius: 50%;
    background-size: cover;
    transition: all 0.10s linear;
  }

  .overlay {
    display: none;
  }

  .overlay {
    top: 65px;
    z-index: 10;
    width: 100%;
    padding: 0 20px;
    position: absolute;
    margin: 0 auto;
  }

  /*  Preview Styles
  ========================== */
  .preview {
    height: 300px;
    padding: 35px 0;
    text-align: center;
  }

  .project-img:hover {
    transform: scale(1.15);

  }

  .project-img:hover:before {
    top: 0;
    left: 0;
    right: 0;
    margin: 0 auto;
    width: 100%;
    content: '';
    height: 100%;
    opacity: 0.95;
    display: block;
    border-radius: 49%;
    position: absolute;
    z-index: 2;
    background-color: #FFF;
  }

  .project-img:hover .overlay {
    display: block;
  }

  /*  Inner Styles
  ========================== */
  .inner {
    position: relative;
  }

  /*  Router Link
========================== */
  .router-link {
    text-decoration: none;
    color: #638E9C;
  }

  /*  Overlay
  ========================== */

  .project-name {
    font-size: 16px;
    font-weight: bold;
  }

  .project-type {
    font-size: 14px;
    margin-bottom: 16px;
  }

  /*  Button styles.
========================== */
  .btn {
    text-transform: uppercase;
    transition: all 0.2s linear;
  }

  .btn.btn-default {
    font-size: 14px;
    background-color: transparent;
    border-color: #638E9C;
    color: #638E9C;
  }

  .btn.btn-default:hover {
    background-color: #638E9C;
    color: #FFF;
  }

  /*  767( Smaller than tablet)
  ========================== */
  @media (max-width: 767px) {
    .project-name {
      font-size: 15px;
      font-weight: bold;
    }

    .project-type {
      margin-bottom: 12px;
    }

    .btn.btn-default {
      font-size: 12px;
    }
  }
</style>



// WEBPACK FOOTER //
// ProjectPreview.vue?9dc5871e